// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"km","information":"kn"};